import script from "./AIAssistantPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AIAssistantPanel.vue?vue&type=script&setup=true&lang=js"

import "./AIAssistantPanel.vue?vue&type=style&index=0&id=3c12af6e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c12af6e"]])

export default __exports__